<template>
  <b-container fluid class="my-1">
    <b-row>
      <b-col class="mx-auto">
        <b-form @submit.prevent="submitForm">
          <b-form-group label="Descripcion:" label-for="nombre">
            <b-form-textarea
              id="nombre"
              v-model="atencion.descripcion"
              type="text"
              rows="5"
              required
            />
          </b-form-group>

          <b-form-group label="Código:" label-for="codigo">
            <b-form-input
              id="codigo"
              v-model="atencion.codTarifa"
              type="text"
              required
            />
          </b-form-group>

          <b-form-group label="Precio Neto:" label-for="precioNeto">
            <b-form-input
              id="precioNeto"
              v-model="atencion.precio"
              type="number"
              required
            />
          </b-form-group>

          <b-form-group>
            <label>Establecimientos:</label>
            <div class="row estab-grid">
              <div
                v-for="est in establecimientosEstado"
                :key="est.value"
                class="col-6 mb-2"
              >
                <div class="estab-item">
                  <span class="estab-label">{{ est.text }}</span>
                  <b-form-checkbox v-model="est.activo" switch class="mb-0" />
                </div>
              </div>
            </div>
          </b-form-group>

          <b-form-group label="Estado:" label-for="estado-switch">
            <b-form-checkbox
              id="estado-switch"
              v-model="atencion.estado"
              value="1"
              unchecked-value="0"
              switch
            />
            <label v-if="atencion.estado === '1' || atencion.estado === 1">
              Activo
            </label>
            <label v-else>
              Inactivo
            </label>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { establecimientosService } from '@/views/administracion/services';
import {
  BContainer,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
} from 'bootstrap-vue';

export default {
  name: 'EditarItemCarteraAtencionV2',
  components: {
    BContainer,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormCheckbox,
  },
  props: ['token'],
  data() {
    return {
      atencion: {
        token: '',
        descripcion: '',
        codTarifa: '',
        precio: 0,
        establecimiento: '',
        estado: 0,
      },
      establecimientosEstado: [],
      establecimientosList: [],
    };
  },
  async created() {
    this.establecimientosList = await establecimientosService.getForSelect();
    await this.fetchAtencion();
  },
  watch: {
    token(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.fetchAtencion();
      }
    },
    establecimientosList() {
      this.syncEstablecimientosEstado();
    },
  },
  methods: {
    parseFlexibleJson(value) {
      if (!value) return {};
      if (typeof value === 'object') return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        try {
          const fixed = value
            .replace(/'/g, '"')
            .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
          return JSON.parse(fixed);
        } catch (error) {
          console.warn('No se pudo parsear JSON flexible', value);
          return {};
        }
      }
    },
    buildEstablecimientosEstado(estRaw) {
      const map = (this.establecimientosList || []).reduce((acc, est) => {
        if (est && est.value !== undefined && est.value !== null) {
          acc[String(est.value)] = est.text;
        }
        return acc;
      }, {});

      const normalize = () => {
        if (!estRaw) return [];
        if (typeof estRaw === 'object' && !Array.isArray(estRaw) && estRaw.id) {
          return [{ id: String(estRaw.id), activo: true }];
        }
        if (Array.isArray(estRaw) && estRaw.length) {
          return estRaw.map(item => {
            if (item && typeof item === 'object') {
              return { id: String(item.id || item.value || item), activo: item.activo !== false };
            }
            return { id: String(item), activo: true };
          });
        }
        if (typeof estRaw === 'string') {
          return estRaw
            .split(',')
            .map(e => e.trim())
            .filter(Boolean)
            .map(entry => {
              const [idRaw, estadoRaw] = entry.split(':').map(val => (val ? val.trim() : ''));
              const id = idRaw || entry;
              const activo = estadoRaw
                ? !['0', 'false', 'inactivo'].includes(estadoRaw.toLowerCase())
                : true;
              return { id, activo };
            });
        }
        return [];
      };

      const normalizados = normalize();
      const activos = new Set(normalizados.filter(e => e.activo).map(e => String(e.id)));
      const ids = normalizados.map(e => String(e.id));

      const baseList = (this.establecimientosList && this.establecimientosList.length
        ? this.establecimientosList
        : ids.map(id => ({ value: id, text: map[id] || id }))) || [];

      const merged = baseList.map(est => ({
        ...est,
        activo: activos.has(String(est.value)),
      }));

      ids.forEach(id => {
        const exists = merged.some(est => String(est.value) === id);
        if (!exists) merged.push({ value: id, text: map[id] || id, activo: activos.has(id) });
      });

      return merged;
    },
    syncEstablecimientosEstado() {
      this.establecimientosEstado = this.buildEstablecimientosEstado(this.atencion.establecimiento);
    },
    async fetchAtencion(pagina_actual = 1, pageSize = 15) {
      if (!this.token) return;
      const query = `
        query MyQuery($page:Int , $pageSize: Int, $tokenAtencion: String) { 
          allCarteraAtencion(page: $page, pageSize: $pageSize, tokenAtencion: $tokenAtencion) {
            message
            status
            total
            atenciones {
              token
              descripcion
              estado
              id
              precio
              codTarifa
              establecimiento
            }
          }
        }
      `;

      const variables = {
        tokenAtencion: this.token,
        page: pagina_actual,
        pageSize,
      };

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        const data = response?.data?.data?.allCarteraAtencion;
        if (data?.status === 'Success' && data.atenciones?.length) {
          const item = data.atenciones[0];
          this.atencion = {
            token: item.token,
            descripcion: item.descripcion,
            codTarifa: item.codTarifa,
            estado: item.estado,
            precio: item.precio,
            establecimiento: item.establecimiento,
          };
          this.syncEstablecimientosEstado();
        } else {
          console.error('Error al obtener la atencion medica:', data?.message);
        }
      } catch (error) {
        console.error('Error al realizar la consulta GraphQL:', error);
      }
    },
    async submitForm() {
      const establecimiento = this.establecimientosEstado.length
        ? this.establecimientosEstado
            .filter(e => e.activo)
            .map(e => e.value)
            .join(',')
        : this.atencion.establecimiento;

      const query = `
        mutation MyMutation($tokenAtencion: String!, $datos: AtenCarteraInput!) {
          actualizarItemCarteraAtencion(
            atencionDatos: $datos
            tokenAtencion: $tokenAtencion
          ) {
            message
            status
            atencionActualizada {
              codTarifa
              descripcion
              estado
              id
              precio
              token
            }
          }
        }
      `;

      const variables = {
        tokenAtencion: this.token,
        datos: {
          descripcion: this.atencion.descripcion,
          codTarifa: this.atencion.codTarifa,
          precio: this.atencion.precio?.toString(),
          establecimiento,
          estado: this.atencion.estado,
        },
      };

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.data.data.actualizarItemCarteraAtencion.status === 'success') {
          await this.$swal({
            icon: 'success',
            title: 'Éxito',
            text: 'Se actualizó la atención correctamente.',
          });
          this.$router.go({ name: 'cartera_atencion_medica' });
        } else {
          throw new Error(response.data.data.actualizarItemCarteraAtencion.message);
        }
      } catch (error) {
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Hubo un problema al actualizar la atención.',
        });
      }
    },
  },
};
</script>

<style scoped>
.estab-grid .col-6 {
  padding-left: 8px;
  padding-right: 8px;
}
.estab-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: #f9fbff;
  min-height: 38px;
}
.estab-label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #344050;
}
</style>
